import { useCallback, useState } from 'react';

interface IModalState<T = any> {
    visible: boolean;
    record?: T;
}

type IReturnValues<T = any> = [
    IModalState<T>,
    (record?: T) => void,
    () => void
];

function useModalState<RecordType = any>(defaultValue?: Partial<IModalState>): IReturnValues<RecordType> {
    const [state, setState] = useState({
        visible: defaultValue?.visible ?? false,
        record: defaultValue?.record as RecordType | undefined
    });

    const openModal = useCallback((record?: RecordType) => {
        setState({
            visible: true,
            record
        });
    }, []);

    const closeModal = useCallback(() => {
        setState({
            visible: false,
            record: undefined
        });
    }, []);

    return [state, openModal, closeModal];
}

export default useModalState;